'use client';

import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import Tab from '@/app/cc/_component/ui/common/Tab/Tab';
import Text from '@/app/cc/_component/ui/common/Text/Text';
import styles from '@/app/cc/_component/ui/section/MainVisual/MainVisual.module.scss';
import { type DealType, useGetDealType, useSetDealType } from '@/app/cc/_stores/useDealTypeStore';
import { sendGA } from '@/app/cc/_util/sendGA';
export default function DealTypeTabs() {
  const $ = _c(21);
  const dealType = useGetDealType();
  const setDealType = useSetDealType();
  let t0;
  if ($[0] !== setDealType) {
    t0 = value => {
      setDealType(value);
    };
    $[0] = setDealType;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const handleChange = t0;
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className={styles.tooltipContent}><Text category="caption" variant="m1" color="var(--color-gray-0)">어떤 계약을 앞두고 계신가요?</Text></div>;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className={styles.tooltip}>{t1}<div className={styles.tooltipArrow}><Image src="/cc/image/icon_downArrow.svg" alt="" aria-hidden="true" fill={true} /></div></div>;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className={styles.leftCorner}><Image src="/cc/image/main/left_corner.svg" alt="" aria-hidden="true" width={46} height={46} /></div>;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== handleChange) {
    t4 = () => {
      handleChange("rent");
      sendGA("rentTabClick");
    };
    $[5] = handleChange;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const t5 = dealType === "rent";
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <span>전월세 계약</span>;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t4 || $[9] !== t5) {
    t7 = <Tab size="lg" name="dealType" color="white" value="rent" active="fill_primary" onChange={t4} checked={t5} className={styles.dealTypeTab}>{t6}</Tab>;
    $[8] = t4;
    $[9] = t5;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== handleChange) {
    t8 = () => {
      handleChange("sale");
      sendGA("saleTabClick");
    };
    $[11] = handleChange;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  const t9 = dealType === "sale";
  let t10;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <span>매매 계약</span>;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== t8 || $[15] !== t9) {
    t11 = <Tab size="lg" name="dealType" color="white" value="sale" active="fill_primary" onChange={t8} checked={t9} className={styles.dealTypeTab}>{t10}</Tab>;
    $[14] = t8;
    $[15] = t9;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <div className={styles.rightCorner}><Image src="/cc/image/main/right_corner.svg" alt="" aria-hidden="true" width={46} height={46} /></div>;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] !== t11 || $[19] !== t7) {
    t13 = <>{t2}<div className={styles.dealTypeTabs}>{t3}{t7}{t11}{t12}</div></>;
    $[18] = t11;
    $[19] = t7;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  return t13;
}